/**
 * Warehouses Pages - Public API Surface
 */

export * from './warehouse-list/warehouse-list.component';
export * from './warehouse-create/warehouse-create.component';
export * from './warehouse-edit/warehouse-edit.component';
export * from './warehouse-detail/warehouse-detail.component';
